



















import Vue, { PropType } from 'vue';

const notificationType = ['notification', 'success', 'error'];

interface DataType {
  // timeout: Function | undefined;
  timeout: any;
}

export default Vue.extend({
  name: 'GNotificationItem',
  props: {
    text: {
      type: String as PropType<string>,
      default: '',
    },
    type: {
      type: String as PropType<string>,
      validator: (prop: string) => notificationType.includes(prop),
      default: 'notification',
    },
    onClickClose: {
      type: Function as PropType<Function>,
      default: null,
    },
    onClickNotification: {
      type: Function as PropType<Function>,
      required: true,
    },
  },
  data(): DataType {
    return {
      timeout: undefined,
    };
  },
  methods: {
    emmitTimeout() {
      this.$emit('timeout');
    },
  },
  mounted() {
    this.timeout = setTimeout(this.emmitTimeout, 3000);
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  },
});
